import { type ReactNode } from 'react';
import { ClientSideHoverFreeze } from '$components/ClientSideHoverFreeze';
import { useSetting } from '$state/hooks/settings';
import { settingsAtom } from '$state/settings';
import * as css from './Reaction.css';

/** Freeze animated custom emoji until hover when Autoplay Emojis is off. */
export function ReactionMedia({ src, children }: { src?: string; children: ReactNode }) {
  const [autoplayEmojis] = useSetting(settingsAtom, 'autoplayEmojis');
  if (!autoplayEmojis && src) {
    return (
      <ClientSideHoverFreeze src={src} className={css.ReactionMediaFreeze}>
        {children}
      </ClientSideHoverFreeze>
    );
  }
  return children;
}
